import { Controller } from "@hotwired/stimulus"

const PASSES = [
  {
    label: "Gyms",
    heading: "Branded digital memberships",
    tagline: "Replace plastic cards with fully branded Apple and Google Wallet passes. Real-time updates — change a tier or credit balance without reprinting anything.",
    avatar: { src: "/customers/gyms/sarah.jpg", srcset: "/customers/gyms/sarah@2x.jpg 2x" },
    passBase: { src: "/customers/gyms/pass__00.png", srcset: "/customers/gyms/pass__00@2x.png 2x" },
    passOverlay: { src: "/customers/gyms/pass__01.png", srcset: "/customers/gyms/pass__01@2x.png 2x" }
  },
  {
    label: "Sports Clubs",
    heading: "Club membership in their pocket",
    tagline: "Issue branded passes to members the moment they join. Gate access, locker access, class bookings — all from one pass, updated in real-time via the API.",
    avatar: { src: "/customers/sports-clubs/debbie.jpg", srcset: "/customers/sports-clubs/debbie@2x.jpg 2x" },
    passBase: { src: "/customers/sports-clubs/pass__00.png", srcset: "/customers/sports-clubs/pass__00@2x.png 2x" },
    passOverlay: { src: "/customers/sports-clubs/pass__01.png", srcset: "/customers/sports-clubs/pass__01@2x.png 2x" }
  },
  {
    label: "Members Clubs",
    heading: "Exclusive access, digitally delivered",
    tagline: "Members receive a digital pass the moment they join. Update tiers, restrict areas, or extend privileges with a single API call — no plastic, no admin.",
    avatar: { src: "/customers/members-clubs/bob.jpg", srcset: "/customers/members-clubs/bob@2x.jpg 2x" },
    passBase: { src: "/customers/members-clubs/pass__00.png", srcset: "/customers/members-clubs/pass__00@2x.png 2x" },
    passOverlay: { src: "/customers/members-clubs/pass__01.png", srcset: "/customers/members-clubs/pass__01@2x.png 2x" }
  },
  {
    label: "Co-working",
    heading: "Seamless access for every member and visitor",
    tagline: "Issue NFC-enabled passes to members, contractors and visitors in one API call. Access is immediate — no app, no hardware swap.",
    avatar: { src: "/customers/co-working/sarah.jpg", srcset: "/customers/co-working/sarah@2x.jpg 2x" },
    passBase: { src: "/customers/co-working/pass__01.png", srcset: "/customers/co-working/pass__01@2x.png 2x" },
    passOverlay: null
  }
]

export default class extends Controller {
  static targets = ["tab", "heading", "tagline", "avatar", "passBase", "passOverlay", "qrCode", "demoSection", "demoLink"]

  static values = { pass: { type: Number, default: 0 } }

  connect() { this.render() }

  select(event) {
    const index = parseInt(event.currentTarget.dataset.passIndex)
    if (index === this.passValue) return
    this.passValue = index
    this.render()
  }

  render() {
    const p = PASSES[this.passValue]

    this.tabTargets.forEach((tab, i) => {
      const active = i === this.passValue
      tab.classList.toggle("bg-gray-50", !active)
    })

    this.headingTarget.textContent = p.heading
    this.taglineTargets.forEach(el => el.textContent = p.tagline)

    this.avatarTarget.src = p.avatar.src
    this.avatarTarget.srcset = p.avatar.srcset

    this.passBaseTarget.src = p.passBase.src
    this.passBaseTarget.srcset = p.passBase.srcset

    if (p.passOverlay) {
      this.passOverlayTarget.src = p.passOverlay.src
      this.passOverlayTarget.srcset = p.passOverlay.srcset
      this.passOverlayTarget.classList.remove("hidden")
    } else {
      this.passOverlayTarget.classList.add("hidden")
    }

    const tab = this.tabTargets[this.passValue]
    const demoUrl = tab.dataset.demoUrl

    if (this.hasQrCodeTarget) {
      this.qrCodeTarget.src = tab.dataset.qrSrc
    }

    if (this.hasDemoSectionTarget) {
      this.demoSectionTarget.classList.toggle("hidden", !demoUrl)
    }

    if (this.hasDemoLinkTarget && demoUrl) {
      this.demoLinkTarget.href = demoUrl
    }
  }
}
